import Model from 'ln/model/Model';
import View from 'ln/view/View';

class BaseView extends View {

	public model:Model;
	
	constructor( model:Model ) {
		super();
		this.model = model;
		
		var modelName = this.model.get<string>( 'modelName' );
		this.defaultTemplate = 'krw.' + modelName.toLowerCase().replace('app\\', '');

	}
	
	public renderData() {
		return this.model;
	}
}

export default BaseView;